import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isLikelyBrowserExtensionError, reportErrorFireAndForget } from './lib/reportErrorClient.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/** Captura global solo en producción: errores JS y promesas rechazadas → Edge report-error */
if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
  window.addEventListener('error', event => {
    const filename = event.filename || '';
    const message = event.message || '';
    if (isLikelyBrowserExtensionError({ message, filename, source: filename })) return;
    const err = event.error;
    const stack =
      err && typeof err.stack === 'string'
        ? err.stack
        : [filename && `at ${filename}`, event.lineno != null && `line ${event.lineno}`].filter(Boolean).join(' ') || null;
    reportErrorFireAndForget(
      {
        tipo: 'js_error',
        mensaje: message || 'window.error sin mensaje',
        stack,
        pagina: window.location.href,
        metadata: {
          filename: filename || null,
          lineno: event.lineno ?? null,
          colno: event.colno ?? null,
        },
      },
      { dedupe: true },
    );
  });

  window.addEventListener('unhandledrejection', event => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason ?? 'unhandledrejection');
    const stack = reason instanceof Error && reason.stack ? reason.stack : null;
    if (isLikelyBrowserExtensionError({ message, filename: '', source: stack || message })) return;
    reportErrorFireAndForget(
      {
        tipo: 'unhandled_rejection',
        mensaje: message,
        stack,
        pagina: window.location.href,
        metadata: { raw_type: reason instanceof Error ? 'Error' : typeof reason },
      },
      { dedupe: true },
    );
  });
}
